/** Collapse same-name API method rows in one sibling list. Namespaces stay separate. */

const PLACEHOLDER_TYPE = 'ApiGridPlaceholder';

function isMethodRow(row) {
    if (!row || typeof row !== 'object')
        return false;
    if (row.Type === 'Namespace' || row.Type === PLACEHOLDER_TYPE)
        return false;
    const name = row.Name == null ? '' : String(row.Name).trim();
    return name !== '';
}

export function apiItemHasDescription(data) {
    const d = data?.Description ?? data?.description;
    if (d == null || d === '')
        return false;
    return String(d).trim() !== '';
}

export function apiItemDescriptionText(data) {
    return String(data?.Description ?? data?.description ?? '').trim();
}

/**
 * One row per method name. The first row is kept; overloadCount is the group size.
 * A later overload's description is kept only when the first row has none.
 * Input rows are not mutated.
 */
export function collapseApiOverloads(rows) {
    if (!Array.isArray(rows))
        return [];
    const out = [];
    const indexByName = new Map();
    for (const row of rows) {
        if (!isMethodRow(row)) {
            out.push(row);
            continue;
        }
        const name = String(row.Name).trim();
        const existing = indexByName.get(name);
        if (existing != null) {
            const kept = out[existing];
            kept.overloadCount = (kept.overloadCount || 1) + 1;
            if (!apiItemHasDescription(kept) && apiItemHasDescription(row))
                kept.Description = row.Description ?? row.description;
            continue;
        }
        indexByName.set(name, out.length);
        out.push({ ...row, overloadCount: 1 });
    }
    return out;
}

export function apiOverloadLabel(row) {
    const name = row?.Name == null ? '' : String(row.Name);
    const count = Number(row?.overloadCount) || 1;
    if (count > 1)
        return `${name} (${count})`;
    return name;
}

/** Tooltip when a name has more than one overload. Empty when there is only one. */
export function apiOverloadTooltip(row) {
    const count = Number(row?.overloadCount) || 1;
    if (count <= 1)
        return '';
    const note = `${count} overloads. Type ( after the name to choose a signature.`;
    const desc = apiItemDescriptionText(row);
    return desc ? `${note}\n${desc}` : note;
}
